import { Provider, Signal } from "@angular/core";
import { ATOM_ALERT_DISMISS_ARIA_LABEL } from "@atomchat-io/ui-design-system";
import { translateSignal } from "@jsverse/transloco";

/**
 * Localizes the default dismiss icon-button of `atom-alert`.
 *
 * Token is a `Signal<string>` and stays in sync on live language switches
 * (`reRenderOnLangChange: true`), same approach as
 * {@link provideAtomRichTextLabels}.
 */
export const provideAtomAlertLabels = (): Provider[] => [
    {
        provide: ATOM_ALERT_DISMISS_ARIA_LABEL,
        useFactory: (): Signal<string> =>
            translateSignal("atom_alert.dismiss_aria_label"),
    },
];
